import React, { useEffect, useState } from 'react';
import { Database, CheckCircle2, AlertOctagon, Loader2 } from 'lucide-react';
import api from '../../utils/axios';
import { haceCuanto } from '../actividad/actividadUtils';

const HORAS_SIN_DATOS = 3;

export const MysqlSalud = ({ refresco }) => {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get('/procesos-automaticos/mysql').then((r) => setD(r.data)).catch(() => setD({ conectada: false }));
  }, [refresco]);

  if (!d) return <div className="rounded-2xl border border-slate-200 bg-white p-5 flex items-center gap-2 text-sm text-slate-400"><Loader2 size={16} className="animate-spin" /> Revisando la base MySQL…</div>;
  const horas = d.ultimo_movimiento ? (Date.now() - new Date(d.ultimo_movimiento).getTime()) / 3600000 : null;
  const problema = !d.conectada ? 'No hay conexión con la base MySQL.'
    : !d.puede_escribir ? 'La base no permite guardar (Hostinger quita el permiso cuando se llena).'
      : horas !== null && horas > HORAS_SIN_DATOS ? `No entran movimientos hace ${Math.floor(horas)} h.` : null;

  return (
    <div className={`rounded-2xl border p-5 flex flex-wrap items-center gap-x-8 gap-y-3 ${problema ? 'border-rose-200 bg-rose-50' : 'border-slate-200 bg-white'}`} data-testid="proc-mysql">
      <div className="flex items-center gap-3">
        <span className={`h-11 w-11 rounded-xl flex items-center justify-center ${problema ? 'bg-rose-100 text-rose-700' : 'bg-teal-50 text-teal-700'}`}><Database size={20} /></span>
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-500">Base de datos MySQL</p>
          <p className="font-bold text-slate-900" data-testid="proc-mysql-base">{d.base || '—'}</p>
        </div>
      </div>
      {d.conectada && (
        <>
          <div><p className="text-[11px] uppercase tracking-wider text-slate-500">Tamaño</p><p className="font-bold tabular-nums text-slate-900" data-testid="proc-mysql-tamano">{Math.round(d.tamano_mb).toLocaleString('es-AR')} MB</p></div>
          <div><p className="text-[11px] uppercase tracking-wider text-slate-500">Guardado</p>
            <p className={`font-bold ${d.puede_escribir ? 'text-emerald-700' : 'text-rose-700'}`} data-testid="proc-mysql-escritura">{d.puede_escribir ? 'Habilitado' : 'Bloqueado'}</p></div>
          <div><p className="text-[11px] uppercase tracking-wider text-slate-500">Último movimiento guardado</p>
            <p className="font-bold text-slate-900" data-testid="proc-mysql-ultimo">{haceCuanto(d.ultimo_movimiento)}</p></div>
        </>
      )}
      <p className={`ml-auto flex items-center gap-1.5 text-sm font-semibold ${problema ? 'text-rose-700' : 'text-emerald-700'}`} data-testid="proc-mysql-estado">
        {problema ? <AlertOctagon size={16} /> : <CheckCircle2 size={16} />} {problema || 'Todo en orden'}
      </p>
    </div>
  );
};

export default MysqlSalud;
